module.exports = __webpack_public_path__ + "img/attention_white.2c876237.svg";